import React, {Component} from 'react'
import './assets-static/stylesheets/theme.css';
import {connect} from "react-redux";
import {loadApplicationData, saveApplicationData} from "./actions/ApplicationAction";
        import EQ_1_1 from "./components/EQ-1.1";
        import EQ_3_3 from "./components/EQ-3.3";
        import EQ_3_4 from "./components/EQ-3.4";
        import EQ_3_5 from "./components/EQ-3.5";
        import EQ_4_1 from "./components/EQ-4.1";
        import EQ_4_2 from "./components/EQ-4.2";
        import EQ_4_3 from "./components/EQ-4.3";
        import EQ_4_4 from "./components/EQ-4.4";
        import EQ_4_5 from "./components/EQ-4.5";
        import EQ_5_1 from "./components/EQ-5.1";
        import EQ_1_2 from "./components/EQ-1.2";
        import EQ_5_2 from "./components/EQ-5.2";
        import EQ_5_3 from "./components/EQ-5.3";
        import EQ_5_4 from "./components/EQ-5.4";
        import EQ_5_5 from "./components/EQ-5.5";
        import EQ_6_1 from "./components/EQ-6.1";
        import EQ_6_2 from "./components/EQ-6.2";
        import EQ_7_1 from "./components/EQ-7.1";
        import EQ_7_2 from "./components/EQ-7.2";
        import EQ_7_3 from "./components/EQ-7.3";
        import EQ_7_4 from "./components/EQ-7.4";
        import EQ_7_5 from "./components/EQ-7.5";
        import EQ_7_6 from "./components/EQ-7.6";
        import EQ_7_7 from "./components/EQ-7.7";
        import EQ_7_8 from "./components/EQ-7.8";
        import EQ_7_9 from "./components/EQ-7.9";
        import EQ_1_3 from "./components/EQ-1.3";
        import EQ_1_4 from "./components/EQ-1.4";
        import EQ_2_1 from "./components/EQ-2.1";
        import EQ_2_2 from "./components/EQ-2.2";
        import EQ_3_1 from "./components/EQ-3.1";
        import EQ_3_2 from "./components/EQ-3.2";
    import { BrowserRouter, Route, Switch } from 'react-router-dom';

class EQ extends Component {
constructor(props) {
super(props);
}

render() {
return (
<div>
    {this.props.application != undefined && this.props.application.applicationData != undefined &&
        <BrowserRouter>
            <Switch>
                                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-1.1">
                            <EQ_1_1 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-3.3">
                            <EQ_3_3 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-3.4">
                            <EQ_3_4 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-3.5">
                            <EQ_3_5 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-4.1">
                            <EQ_4_1 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-4.2">
                            <EQ_4_2 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-4.3">
                            <EQ_4_3 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-4.4">
                            <EQ_4_4 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-4.5">
                            <EQ_4_5 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-5.1">
                            <EQ_5_1 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-1.2">
                            <EQ_1_2 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-5.2">
                            <EQ_5_2 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-5.3">
                            <EQ_5_3 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-5.4">
                            <EQ_5_4 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-5.5">
                            <EQ_5_5 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-6.1">
                            <EQ_6_1 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-6.2">
                            <EQ_6_2 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.1">
                            <EQ_7_1 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.2">
                            <EQ_7_2 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.3">
                            <EQ_7_3 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.4">
                            <EQ_7_4 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.5">
                            <EQ_7_5 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.6">
                            <EQ_7_6 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.7">
                            <EQ_7_7 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.8">
                            <EQ_7_8 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-7.9">
                            <EQ_7_9 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-1.3">
                            <EQ_1_3 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-1.4">
                            <EQ_1_4 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-2.1">
                            <EQ_2_1 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-2.2">
                            <EQ_2_2 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-3.1">
                            <EQ_3_1 />
                        </Route>
                                            <Route path="/ircitizenship/interactions/eq/users/0/applications/0/pages/EQ-3.2">
                            <EQ_3_2 />
                        </Route>
                                                </Switch>
        </BrowserRouter>
    }
</div>)
}
}

const mapDispatchToProps = (dispatch) => {
loadApplicationData("ircitizenship").then((data) => {
return {
application: dispatch(data).payload
}
})
return dispatch(saveApplicationData({}))
};

const mapStateToProps = state => {
return {
application: state.application
}
};

export default connect(mapStateToProps, mapDispatchToProps)(EQ)
